/* ez-pdp-length-select.js — the shade-roll LENGTH dropdown.
   Two jobs:
     1. Navigate: each length is its own product/PDP, so choosing an option loads that roll's page.
     2. Kit price: a roll is sold as a "shade kit" (roll + recommended snaps). The headline shows the
        COMPOSED kit price (roll + medium-tier snaps), so the dropdown must too, or the numbers disagree.
        We recompute each option with the SAME shade engine the header uses (window.EZSnap → rollLine),
        fed each length's roll price + recommended (medium) snap count from the option's data-* — so the
        dropdown kit price matches load-in BY CONSTRUCTION, never a re-derivation that could drift.
   The server renders each option as a roll-price fallback ("3 ft · $39.99"); this upgrades it in place to
   the kit price ("3 ft + snaps · $79.98"). If the engine never loads, the roll-price fallback stands —
   which is exactly what the headline also falls back to, so the two stay consistent either way. */
(function () {
  'use strict';

  function money(n) {
    n = Number(n) || 0;
    // non-store currency (Canada market = CAD): the ONE theme formatter, window.EZ (layout/theme.liquid)
    var E = window.EZ;
    if (E && E.isBase === false && typeof E.money === 'function') return E.money(n);
    return '$' + n.toLocaleString('en-US', {
      minimumFractionDigits: n % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2
    });
  }

  // colour NAME (colour-card value) → SKU colour code, mirroring ez-pdp-snap-tiers.js so the engine
  // catalog is filtered to the SAME colour the header prices in.
  function colorCode(name) {
    var n = String(name || '').trim().toLowerCase();
    if (n === 'white' || n === 'wh') return 'WH';
    if (n === 'beige' || n === 'bg') return 'BG';
    if (n === 'grey' || n === 'gray' || n === 'gy') return 'GY';
    return 'BK';
  }

  function currentColorName(root) {
    var picked = (root || document).querySelector('.ez-pdp__colour-card input:checked, .ez-pdp__swatch input:checked');
    return picked ? picked.value : 'Black';
  }

  function priceUp(sel, root) {
    // need the shared shade engine (same one the headline uses) + the SNA catalog payload on the page.
    if (!(window.EZSnap && window.EZSnap.createShadeEngine)) {
      return setTimeout(function () { priceUp(sel, root); }, 80);
    }
    var catEl = (root || document).querySelector('[data-ez-snap-catalog]');
    if (!catEl) return; // no snap kit on this page → leave the roll-price fallback text
    var cfg;
    try { cfg = JSON.parse(catEl.textContent); } catch (e) { return; }

    var code = colorCode(currentColorName(root));
    var snaPacks = (cfg.snaPacks || []).filter(function (p) { return p.color === code; });
    var opts = Array.prototype.slice.call(sel.options);

    // one synthetic roll row per length (medium tier only) → rollLine(ft,'medium') === the headline path.
    var rolls = opts.map(function (o) {
      return {
        ft: parseInt(o.dataset.ft, 10),
        color: code,
        price: (parseInt(o.dataset.rollCents, 10) || 0) / 100,
        snaps: { medium: parseInt(o.dataset.medium, 10) || 0 }
      };
    }).filter(function (r) { return r.ft && r.snaps.medium; });

    var eng = window.EZSnap.createShadeEngine({ rolls: rolls, snaPacks: snaPacks });

    opts.forEach(function (o) {
      var ft = parseInt(o.dataset.ft, 10);
      var med = parseInt(o.dataset.medium, 10) || 0;
      var label = o.dataset.label || (ft ? ft + ' ft' : o.textContent);
      if (ft && med) {
        var L = eng.rollLine(ft, 'medium');
        if (L && L.price != null) { o.textContent = label + ' + snaps · ' + money(L.price); return; }
      }
      // fallback: roll-only price
      var rollDollars = (parseInt(o.dataset.rollCents, 10) || 0) / 100;
      o.textContent = label + ' · ' + money(rollDollars);
    });

    // kit price is colour-bound like the headline — repaint when the colour card changes.
    (root || document).querySelectorAll('.ez-pdp__colour-card input, .ez-pdp__swatch input').forEach(function (inp) {
      if (inp.dataset.ezLenColorBound === '1') return;
      inp.dataset.ezLenColorBound = '1';
      inp.addEventListener('change', function () { priceUp(sel, root); });
    });
  }

  function initSelect(sel) {
    if (sel.dataset.ezLenInit === '1') return;
    sel.dataset.ezLenInit = '1';
    var root = sel.closest('.ez-pdp');
    // navigate on change — wired FIRST + unconditionally, so length switching works even if pricing can't.
    sel.addEventListener('change', function () { if (this.value) { window.location.href = this.value; } });
    priceUp(sel, root);
  }

  function initAll() {
    document.querySelectorAll('[data-ez-length-nav]').forEach(initSelect);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target || document;
    (t.querySelectorAll ? t.querySelectorAll('[data-ez-length-nav]') : []).forEach(initSelect);
  });
})();
